import { addCommitmentNotesEpic } from './state/add-commitment-notes.epic';
import { reloadEpic } from './state/reload.epic';

export const teamschatTranscriptDialogEpics = [
    reloadEpic,
    addCommitmentNotesEpic,
];
